import {
  ShoppingCartIcon,
  DollarSignCircleIcon,
  ThumbUpOutlineIcon,
} from '@grupoboticario/flora-react-icons';
import type { CheckoutStepsMapper } from './HeaderCheckout.d';

export const checkoutStepsMapper: CheckoutStepsMapper = {
  cart: {
    icon: function IconShoppingCart() {
      return <ShoppingCartIcon />;
    },
    name: 'Carrinho',
  },
  payment: {
    icon: function IconMoney() {
      return <DollarSignCircleIcon />;
    },
    name: 'Pagamento',
  },
  summary: {
    icon: function IconRateLike() {
      return <ThumbUpOutlineIcon />;
    },
    name: 'Revisão',
  },
};
